import React from 'react';
import { DataGrid } from 'devextreme-react';
import { Item } from 'devextreme-react/form';
import { 
    Paging, 
    Pager, 
    FilterRow, 
    HeaderFilter, 
    ColumnChooser, 
    Column, 
    Export, 
    Editing,
    Popup,     
    Form, 
    RequiredRule,
    StringLengthRule} from 'devextreme-react/data-grid';

import uri from '../../utils/uri';
import { store } from '../../services/store';
import Title from '../../components/shared/Title';
import BlockHeader from '../../components/shared/BlockHeader';

const Activities = () => {

    const cellRender = data=> {
        return (
            <div style={{ display: 'flex' }}>{data.text} 
                <div className="box-color-value" style={{backgroundColor: data.text}}></div>
            </div>
        )
    }

    const cellRenderPrev = data=> {
        return (           
            <div className="" style={{ backgroundColor: data.data.color}}>
                <p style={{ padding: "2px",color: data.data.fontColor}}>{data.data.name}</p>
            </div>            
       )
    }

    const title = 'Actividades';

    return (
        <div className="container medium">
        <Title title={title}/>
        <BlockHeader title={title}/>          
        <DataGrid id="gridContainer"
            selection={{ mode: 'single' }}
            dataSource={store({uri : uri.activities})}
            showBorders={true}
            showRowLines={true}
            allowColumnResizing={true}
            allowColumnReordering={true}
            rowAlternationEnabled={true}
        >
            <Paging defaultPageSize={20} />
            <Pager
                showPageSizeSelector={true}
                allowedPageSizes={[10, 20, 50]}
            />
            <FilterRow visible={true} />
            <HeaderFilter visible={true} />
            <ColumnChooser enabled={true} />
            <Export enabled={true} fileName={title} allowExportSelectedData={true} />
            <Column dataField="name" />
            <Column width={200} dataField="fontColor" caption="Color de texto" cellRender={cellRender} />
            <Column width={200} dataField="color" caption="Color de relleno" cellRender={cellRender} />
            <Column width={200} dataField="prev" caption="Previa" cellRender={cellRenderPrev} />
            <Editing
                mode="popup"
                allowUpdating={true}
                allowDeleting={true}
                allowAdding={true}
                useIcons={true}
            >
                <Popup title={title} showTitle={true} width={400} height={300}>
                    
                </Popup>
                <Form colCount={1}>
                    <Item  dataField="name" >
                        <RequiredRule message="La descripcion es requerida"/>
                        <StringLengthRule max={50} min={2} message="Máximo de caracteres 50 y 2 mínimo"/>
                    </Item>                    
                    <Item  dataField="fontColor" editorType="dxColorBox">
                    </Item>                    
                    <Item  dataField="color" editorType="dxColorBox">
                    </Item>                    
                </Form>
            </Editing>
        </DataGrid>
    </div>
    );
}

export default Activities;
